import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useHeroImage = () => {
  return useQuery({
    queryKey: ['hero-image'],
    queryFn: async () => {
      const { data } = await supabase
        .from('homepage_settings')
        .select('image_url')
        .eq('key', 'hero_image')
        .maybeSingle();
      return data?.image_url || null;
    },
    staleTime: 0,
    gcTime: 0,
  });
};

export const useHeroSlides = () => {
  return useQuery({
    queryKey: ['hero-slides'],
    queryFn: async () => {
      const { data } = await supabase
        .from('homepage_settings')
        .select('key, image_url')
        .in('key', ['hero_slide_1', 'hero_slide_2', 'hero_slide_3']);
      const slides = ['hero_slide_1', 'hero_slide_2', 'hero_slide_3']
        .map(k => data?.find(d => d.key === k)?.image_url || '')
        .filter(Boolean);
      return slides;
    },
    staleTime: 0,
    gcTime: 0,
  });
};
